import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import type { TelemetryPoint } from '../../api/types'

export function UtilizationChart({
  series,
  height = 300,
}: {
  series: TelemetryPoint[]
  height?: number
}) {
  const data = series.map((item) => ({
    ...item,
    time: new Intl.DateTimeFormat('en-GB', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Asia/Bangkok',
    }).format(new Date(item.timestamp)),
  }))
  if (!data.length) return <div className="chart-empty">No telemetry is available for this range.</div>
  return (
    <div style={{ width: '100%', height }} aria-label="GPU and memory activity chart">
      <ResponsiveContainer>
        <AreaChart data={data} margin={{ top: 12, right: 8, left: -18, bottom: 0 }}>
          <defs>
            <linearGradient id="gpuFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#b41625" stopOpacity={0.35} />
              <stop offset="95%" stopColor="#b41625" stopOpacity={0.02} />
            </linearGradient>
            <linearGradient id="memoryFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#008dcc" stopOpacity={0.28} />
              <stop offset="95%" stopColor="#008dcc" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="time" minTickGap={45} tick={{ fontSize: 11 }} />
          <YAxis
            domain={[0, 100]}
            tickFormatter={(value: number) => `${value}%`}
            tick={{ fontSize: 11 }}
          />
          <Tooltip
            formatter={(value) => [
              Array.isArray(value) ? value.join(', ') : `${Number(value ?? 0).toFixed(1)}%`,
            ]}
          />
          <Legend />
          <Area
            type="monotone"
            dataKey="gpuUtilizationPct"
            name="GPU processing"
            stroke="#b41625"
            fill="url(#gpuFill)"
            strokeWidth={2}
            isAnimationActive={false}
          />
          <Area
            type="monotone"
            dataKey="memoryUtilizationPct"
            name="Memory activity"
            stroke="#008dcc"
            fill="url(#memoryFill)"
            strokeWidth={2}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  )
}
